import { render, staticRenderFns } from "./Testimonials.vue?vue&type=template&id=60714928&scoped=true&"
import script from "./Testimonials.vue?vue&type=script&lang=js&"
export * from "./Testimonials.vue?vue&type=script&lang=js&"
import style0 from "./Testimonials.vue?vue&type=style&index=0&id=60714928&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60714928",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Testimonials.vue
// module id = null
// module chunks = 